import { render, staticRenderFns } from "./editNotifications.vue?vue&type=template&id=acb04f30&"
import script from "./editNotifications.vue?vue&type=script&lang=js&"
export * from "./editNotifications.vue?vue&type=script&lang=js&"
import style0 from "./editNotifications.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports